'use client';
import { useCurrencyString } from '@hooks/useCurrencyString';
import { classNames } from '@repo/ui/src/utils/classNames';
import useTranslation from '@components/Translation/useTranslation';
import React from 'react';

interface SummaryLineProps {
  title: string;
  value: number | null;
  currency?: string;
  bold?: boolean;
  freeLabel?: string;
}

const SummaryLine = ({ title, value, bold, currency, freeLabel }: SummaryLineProps) => {
  const getCurrencyString = useCurrencyString(currency);
  const { t } = useTranslation();
  const free = value === 0;

  const freeText =
    freeLabel || t('addToCartWindowContent.freeLabel', undefined, { default: 'Free' });

  return (
    <div className="tw-flex tw-justify-between">
      <p className={classNames('tra-text-web-body-m tw-m-0', bold && 'tw-font-bold')}>{title}</p>
      <p className={classNames('tra-text-web-body-m tw-m-0', bold && 'tw-font-bold')}>
        {free ? freeText : getCurrencyString(value)}
      </p>
    </div>
  );
};

export default SummaryLine;
